import { TwcProduct } from '../../../twc-products';

export const RADAR_ECHO_TOPS_PRODUCT_DATA: TwcProduct = {
  id: 'radar-echo-tops',
  defaultProductId: 'echotopsNowradCONUS-boeing',
  productName: 'Weather-EchoTops-TWC',
  label: 'Radar Echo Tops',
  weatherType: 'ECHO_TOPS',
  description: 'TWC product (raster) - Radar Echo Tops',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 9,
  protocol: 'WebTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90
};
